import { MixpanelEventName, useAnalytics } from '@/app/utils/useAnalytics';
import cx from 'classnames';
import Link from 'next/link';
import { useRef } from 'react';

import styles from './NavDropdownSubItem.module.scss';

interface NavDropdownSubItemProps {
  id?: string;
  label: React.ReactNode;
  to: string;
  testid?: string;
  trackEventName?: MixpanelEventName;
  isActiveLink: boolean;
  onNavItemClick?: () => void;
  setOpen: (open: boolean) => void;
}

export const NavDropdownSubItem = ({
  id,
  label,
  to,
  testid,
  trackEventName,
  onNavItemClick,
  setOpen,
  isActiveLink,
}: NavDropdownSubItemProps) => {
  const track = useAnalytics();
  const linkRef = useRef<HTMLAnchorElement>(null);
  return (
    <Link
      ref={linkRef}
      prefetch={false}
      href={to}
      as={to}
      passHref
      className={cx(styles.navDropdownSubItem, isActiveLink && styles.activeLink)}
      data-testid={testid}
      id={`${id}-${label}`}
      tabIndex={0}
      onClick={() => {
        trackEventName && track(trackEventName, {});
        setOpen(false);
        onNavItemClick?.();
      }}
      onKeyDown={e => {
        // Anchors already fire onClick on Enter natively - only Space needs to be handled here,
        // otherwise the tracking/close logic above runs twice on Enter (once from onKeyDown,
        // once from the native onClick).
        if (e.code === 'Space') {
          e.preventDefault();
          linkRef.current?.click();
        }
      }}
    >
      {label}
    </Link>
  );
};
